<div style="display: flex; justify-content: center; align-items: center; height: 99vh; flex-direction: column;">
  <h2>
    {{ paywallService.settings()?.thankYouData?.thankYouText }}
  </h2>
  @if (confirmationLine()) {
    <p class="paywall-success__quantity">{{ confirmationLine() }}</p>
  }
</div>